<template>
<div class="chapter">
<div class="inner_page">
<a id="p2"></a>
<p class="center sink">
<em>For all of us</em>
</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?6dc5e44a